import React, { useState } from "react";
import { ProfileCard, CandidatDrawer } from "@viewComponents/profile_utils";

interface Candidat {
  id: number;
  name: string;
  project_contribution?: number;
  secteurs?: string[];
  experience?: string;
  franchise_interest?: boolean;
  surface_range?: number[] | null;
  address?: {
    postal_code: string;
    locality: string;
    formatted_address: string;
    latitude: number;
    longitude: number;
    administrative_area_level_1?: string | null;
    country: string;
  } | null;
}

interface SearchCandidatsProps {
  count: number;
  candidats?: Candidat[];
  message?: string;
}

export const SearchCandidatsResult: React.FC<SearchCandidatsProps> = ({
  count,
  candidats = [],
  message,
}) => {
  const [selectedCandidat, setSelectedCandidat] = useState<Candidat | null>(
    null,
  );

  if (count === 0 || message) {
    return (
      <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 text-sm text-gray-600">
        {message || "Aucun candidat trouvé"}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="text-sm font-medium text-gray-700">
        {count} candidat{count > 1 ? "s" : ""} trouvé{count > 1 ? "s" : ""}
      </div>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {candidats.map((candidat) => {
          // Map to ProfileCard expected format
          const mappedCandidat = {
            id: candidat.id,
            name: candidat.name,
            avatar_url: undefined,
            project_contribution: candidat.project_contribution,
            project_sectors: candidat.secteurs,
            project_address: candidat.address?.formatted_address,
          };

          return (
            <ProfileCard
              key={candidat.id}
              entity={mappedCandidat}
              entityType="candidats"
              onClick={() => setSelectedCandidat(candidat)}
              onDetailClick={() => setSelectedCandidat(candidat)}
            />
          );
        })}
      </div>

      {selectedCandidat && (
        <CandidatDrawer
          candidat={selectedCandidat}
          onClose={() => setSelectedCandidat(null)}
        />
      )}
    </div>
  );
};
